// Environment-specific base URLs
export const DEV_API_URL = 'https://phenixloc-api.fnvt.net/api';
export const PROD_API_URL = 'https://phenixlocapi.fnvt.net/api';

export const IS_TEST = false;

// Use the appropriate URL based on environment
export const API_BASE_URL = IS_TEST === true ? DEV_API_URL : PROD_API_URL;

// Auth endpoints
export const AUTH_ENDPOINTS = {
  REGISTER: `${API_BASE_URL}/auth/register`,
  VALIDATE_ACTIVATION_CODE: `${API_BASE_URL}/auth/activation-code/validate`,
  VERIFY_EMAIL: `${API_BASE_URL}/auth/verify-email`,
  LOGIN: `${API_BASE_URL}/auth/login`,
  LOGIN_WITH_PHRASES: `${API_BASE_URL}/auth/login-with-phrases`,
  CHECK_USER_EXISTS: `${API_BASE_URL}/auth/check-user-exists`,
  INITIATE_RECOVERY: `${API_BASE_URL}/auth/initiate-recovery`,
  VERIFY_RECOVERY_OTP: `${API_BASE_URL}/auth/verify-recovery-otp`,
  RESET_PASSWORD_WITH_OTP: `${API_BASE_URL}/auth/reset-password-with-otp`,
  VERIFY_MNEMONIC_CHANGE_PASSWORD: `${API_BASE_URL}/auth/verify-mnemonic-and-change-password-out`,
};

// User endpoints
export const USER_ENDPOINTS = {
  ACCOUNT_DETAILS: `${API_BASE_URL}/user/fetch-account-details`,
  EDIT_PROFILE: `${API_BASE_URL}/user/edit-user`,
  LOGIN_HISTORY: `${API_BASE_URL}/user/login-history`,
  ACCOUNT_HISTORY: `${API_BASE_URL}/user/account-history`,
  UPLOAD_PROFILE_IMAGE: `${API_BASE_URL}/user/upload-profile-image`,
  GET_PROFILE_IMAGE: `${API_BASE_URL}/user/profile-image`,
  DELETE_PROFILE_IMAGE: `${API_BASE_URL}/user/profile-image`,
  GET_ALERTS: `${API_BASE_URL}/user/alerts`,
  CLEAR_ALERT: `${API_BASE_URL}/user/alerts/:id/clear`,
  CLEAR_ALL_ALERTS: `${API_BASE_URL}/user/alerts/clear-all`,
  INITIATE_EMAIL_CHANGE: `${API_BASE_URL}/user/initiate-email-change`,
  CHANGE_EMAIL: `${API_BASE_URL}/user/change-email`,
  INITIATE_PASSWORD_CHANGE: `${API_BASE_URL}/user/initiate-password-change`,
  VERIFY_PASSWORD_CHANGE: `${API_BASE_URL}/user/verify-password-change`,
  VERIFY_MNEMONIC_CHANGE_PASSWORD: `${API_BASE_URL}/user/verify-mnemonic-and-change-password`,
  VERIFY_MNEMONIC_OTP_CHANGE_PASSWORD: `${API_BASE_URL}/user/verify-mnemonic-otp-and-change-password`,
};

// Subscription endpoints
export const SUBSCRIPTION_ENDPOINTS = {
  GET_ALL_PLANS: `${API_BASE_URL}/subscription/subscription-plans`,
  GET_PLAN_BY_ID: `${API_BASE_URL}/subscription/subscription-plan`,
  UPDATE_PLAN: `${API_BASE_URL}/subscription/update-subscription-plan`,
  CURRENT_SUBSCRIPTION: `${API_BASE_URL}/subscription/current-subscription`,
  UPDATE_ACCOUNT_STATUS: `${API_BASE_URL}/subscription/update-account-status`,
  INIT_PAYMENT: `${API_BASE_URL}/subscription/init-payment`,
  VERIFY_PAYMENT: `${API_BASE_URL}/subscription/verify-payment`,
  PAYMENT_HISTORY: `${API_BASE_URL}/subscription/payment-history`,
  CREATE_PAYPAL_ORDER: `${API_BASE_URL}/subscription/create-paypal-order`,
  CAPTURE_PAYPAL_ORDER: `${API_BASE_URL}/subscription/capture-paypal-order`,
  VERIFY_PAYPAL_PAYMENT: `${API_BASE_URL}/subscription/verify-paypal-payment`,

  INIT_CRYPTO_PAYMENT: `${API_BASE_URL}/subscription/init-crypto-payment`,
  VERIFY_CRYPTO_PAYMENT: `${API_BASE_URL}/subscription/verify-crypto-payment`,
  GET_CRYPTO_PAYMENT_STATUS: `${API_BASE_URL}/subscription/crypto-payment-status`,
};

// Upload endpoints
export const UPLOAD_ENDPOINTS = {
  SINGLE_FILE: `${API_BASE_URL}/upload/files/single`,
  INITIATE_MULTIPART: `${API_BASE_URL}/upload/files/initiate`,
  UPLOAD_PART: `${API_BASE_URL}/upload/files/upload-part`,
  COMPLETE_MULTIPART: `${API_BASE_URL}/upload/files/complete`,
  ABORT_MULTIPART: `${API_BASE_URL}/upload/files/abort`,
  UPLOAD_FOLDER: `${API_BASE_URL}/upload/folder`,
  UPLOAD_IN_FOLDER: `${API_BASE_URL}/upload/in-folder`,
  CREATE_FOLDER: `${API_BASE_URL}/upload/create-folder`,
  UPLOAD_PASSWORD: `${API_BASE_URL}/upload/password`,
  UPLOAD_PHRASES: `${API_BASE_URL}/upload/phrases`,
  UPLOAD_CARD: `${API_BASE_URL}/upload/card`,
  RENAME_CARD: `${API_BASE_URL}/upload/files/rename`,
};

// Download endpoints
export const DOWNLOAD_ENDPOINTS = {
  FILE: `${API_BASE_URL}/download/file`,
  FOLDER: `${API_BASE_URL}/download/folder`,
  METADATA: `${API_BASE_URL}/download/metadata`,
  GENERATE_DOWNLOAD_URL: `${API_BASE_URL}/download/generate-download-url`,
  GENERATE_CUSTOM_URL: `${API_BASE_URL}/download/generate-custom-url`,
  GENERATE_BATCH_URLS: `${API_BASE_URL}/download/generate-batch-urls`,
  DOWNLOAD_PROXY: `${API_BASE_URL}/download/proxy`
};

// Content endpoints
export const CONTENT_ENDPOINTS = {
  BUCKET_CONTENT: `${API_BASE_URL}/content/bucket`,
  BUCKET_CONTENT_PAGE: `${API_BASE_URL}/content/bucket/page`,
  FOLDER_CONTENT: `${API_BASE_URL}/content/folder`,
  ALL_BUCKETS_SIZE: `${API_BASE_URL}/content/sizes/all`,
  BUCKETS_SIZE: `${API_BASE_URL}/content/sizes`,
};

// Contact endpoints
export const CONTACT_ENDPOINTS = {
  SUBMIT_FORM: `${API_BASE_URL}/contact/submit`,
  CONTACT_SUPPORT: `${API_BASE_URL}/contact/support`,
  GOOGLE_SHEETS: 'https://script.google.com/macros/s/AKfycbx6zy0bHyRYXRxGb__S0dnsqigh43UsWbcdk1EdpdeP5PnC6q3G7NcnAjnR2fBraWYanw/exec'
};

// Recipient endpoints
export const RECIPIENT_ENDPOINTS = {
  INITIATE_RECOVERY: `${API_BASE_URL}/recipient/initiate-recovery`,
  VERIFY_RECOVERY: `${API_BASE_URL}/recipient/verify-recovery`,
  SAVE_NEW_CREDENTIALS: `${API_BASE_URL}/recipient/save-new-credentials`,
  LOGIN: `${API_BASE_URL}/recipient/login`,
  REJECT_INHERITANCE: `${API_BASE_URL}/recipient/reject-inheritance`,
  ACKNOWLEDGE_INHERITANCE: `${API_BASE_URL}/recipient/acknowledge`,
  GET_INHERITANCES: `${API_BASE_URL}/recipient/inheritances`,
  CHANGE_PASSWORD: `${API_BASE_URL}/recipient/change-password`,
};

// Delete endpoints
export const DELETE_ENDPOINTS = {
  FILE: `${API_BASE_URL}/delete/file`,
  FOLDER: `${API_BASE_URL}/delete/folder`,
  ALL_INHERITANCE: `${API_BASE_URL}/delete/all-inheritance`,
  INHERITANCE_DB: `${API_BASE_URL}/delete/inheritance-db`,
  SELECTED_FILES: `${API_BASE_URL}/delete/selected`,
};

// Stream endpoints
export const STREAM_ENDPOINTS = {
  FILE: `${API_BASE_URL}/stream/file`,
  GENERATE_VIEW_URL: `${API_BASE_URL}/download/generate-view-url`
};

// Inheritance endpoints
export const INHERITANCE_ENDPOINTS = {
  EDIT: `${API_BASE_URL}/inheritance/edit`,
  UPLOAD: `${API_BASE_URL}/inheritance/upload`,
  RESEND: `${API_BASE_URL}/inheritance/resend`,
  CHECK_AVAILABILITY: `${API_BASE_URL}/inheritance/check-availability`,
  STATUS: `${API_BASE_URL}/inheritance/status`,
  DURATION: `${API_BASE_URL}/inheritance/duration`,
  CHECK_RECIPIENT_EMAIL: `${API_BASE_URL}/inheritance/check-recipient-email`,
};

// Application constants
export const APP_NAME = 'PhenixLoc';
export const APP_VERSION = '1.0.0';

// Local storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'phenixloc_auth_token',
  USER_INFO: 'phenixloc_user_info',
  THEME: 'phenixloc_theme',
  LANGUAGE: 'phenixloc_language',
};

// Default settings
export const DEFAULT_SETTINGS = {
  ITEMS_PER_PAGE: 10,
  THEME: 'light',
  LANGUAGE: 'en',
};

// Admin routes (for reference - not typically used in frontend)
export const ADMIN_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/admin-login`,
  UPDATE_LOGIN: `${API_BASE_URL}/admin-update-login`,
  DASHBOARD_STATS: `${API_BASE_URL}/dashboard-stats`,
  RECENT_ACTIVITY: `${API_BASE_URL}/recent-activity`,
  USERS: `${API_BASE_URL}/users`,
  USER_BY_ID: `${API_BASE_URL}/users/:userId`,
  USER_ACTION: `${API_BASE_URL}/users/action`,
};

export const paypalOptions = {
  "client-id": "AbrY1SAn73kF3TO3NN6grXhI2TI1vORgPDd9sUmnvzbwxd4hUuvMOZGd_CjUE02VTqlqAQw6PCWI6ff3",
  currency: "USD",
  intent: "capture"
};